<script>
  // [08/23] https://tailwindui.com/components/application-ui/forms/input-groups
  export let value;
  export let label = undefined;
  export let placeholder = undefined;
  export let note = undefined;
  export let link = undefined;
  export let cssClass = undefined;
</script>

<div class="tailwind input {cssClass || ''}">
  <div>
    {#if label}
      <div class="flex items-center justify-between">
        <!-- svelte-ignore a11y-label-has-associated-control -->
        <label class="block text-sm font-medium leading-6 text-neutral-900 dark:text-white">
          {label}
        </label>

        {#if note}
          {#if link}
            <a href={link} target="_blank" class="text-sm font-medium leading-6 text-blue-600 dark:text-blue-500 hover:text-blue-500 dark:hover:text-blue-400">
              {note}
            </a>
          {:else}
            <span class="text-sm leading-6 text-neutral-500 dark:text-neutral-400">
              {note}
            </span>
          {/if}
        {/if}
      </div>
    {/if}

    <div class={label ? 'mt-2' : ''}>
      <input bind:value={value} placeholder={placeholder} type="text" class="block w-full rounded-md border-0 bg-white dark:bg-neutral-800 py-1.5 text-neutral-900 dark:text-white shadow-sm ring-1 ring-inset ring-neutral-300 dark:ring-neutral-500 placeholder:text-neutral-400 dark:placeholder:text-neutral-500 focus:ring-2 focus:ring-inset focus:ring-blue-600 dark:focus:ring-blue-500 text-sm leading-6">
    </div>
  </div>
</div>
